import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {authenticationStatusSelector} from "../states/user/userSelectors";
import {authLoadingState} from "../states/user/userAtom";

export function PrivateRoute() {
    const location = useLocation()
    const isAuthLoading = useRecoilValue(authLoadingState);
    const isAuthenticated = useRecoilValue(authenticationStatusSelector);
    if (isAuthLoading) {
        return <div>Loading...</div>
    }

    return isAuthenticated ? <Outlet /> : <Navigate to={`/login?redirect=${location.pathname}`} />
}
